import { IProjectLoanPurpose } from '~/@api/generated-api-types-project/Api'

const projectLoanPurpose = {
  [IProjectLoanPurpose.Reconstruction]: 'Rekonštrukcia',
  [IProjectLoanPurpose.Construction]: 'Výstavba',
  [IProjectLoanPurpose.Investment]: 'Investícia',
  [IProjectLoanPurpose.Buying]: 'Nákup',
  [IProjectLoanPurpose.Business]: 'Podnikanie',
  [IProjectLoanPurpose.Purchase]: 'Na kúpu',
  [IProjectLoanPurpose.Refinancing]: 'Refinancovanie',
  [IProjectLoanPurpose.Development]: 'Development',
  [IProjectLoanPurpose.Flipping]: 'Flipping',
}

export function getProjectLoanPurposeLabel(key: IProjectLoanPurpose) {
  return projectLoanPurpose[key]
}
